TS.ns('WL');

WL.leasingApplicationChecklistModel = new Class({
    Extends: WL.leasingApplicationBaseModel,

    createProperties: function (config) {
        var me = this;

        me.parent(config);

        var grid = me.getDomainProperty('dgLeasingApplicationCheckListCollection_Property');

        if (grid != null) { 
            grid.on('cellValueChanged', me.onChecklistChecked);

            var cat = grid.Commands;
            newCmd = new TS.domain.Command();  
            newCmd['Code'] = 'CheckAll1';
            newCmd['Text'] = me.CheckListCheck1CommandText();
            newCmd['handler'] = 'onCheckAll1';
            newCmd['IconCode'] = 'check-square-o';   
            if (!me.ReadOnly())
                cat.push(newCmd);

            newCmd = new TS.domain.Command();
            newCmd['Code'] = 'UncheckAll1';
            newCmd['Text'] = me.CheckListUncheck1CommandText();
            newCmd['handler'] = 'onCheckAll1';
            newCmd['IconCode'] = 'square-o';
            if (!me.ReadOnly())
                cat.push(newCmd);
            
            newCmd = new TS.domain.Command();
            newCmd['Code'] = 'CheckAll2';
            newCmd['Text'] = me.CheckListCheck2CommandText();
            newCmd['handler'] = 'onCheckAll2';
            newCmd['IconCode'] = 'check-square-o';
            if (!me.ReadOnly())
                cat.push(newCmd);

            newCmd = new TS.domain.Command();
            newCmd['Code'] = 'UncheckCheckAll2';
            newCmd['Text'] = me.CheckListUncheck2CommandText();
            newCmd['handler'] = 'onCheckAll2';
            newCmd['IconCode'] = 'square-o';
            if (!me.ReadOnly())
                cat.push(newCmd);
            
        }
    },

    onChecklistChecked:function(e){
        var me = this,
            owner = me._getOwner(),
            val = e.newValue;

        if (e.oldValue == e.newValue)
            return;


        if (e.fieldName == 'Checked') {

            e.preventDefault();

            owner.performServerCommand({
                cmd: 'CheckListCkecked',
                submitModel: true,
                extraData: {
                    rowIdx: e.rowIdx,
                    fieldName: 'Checked',
                    value: e.newValue
                },
                blockUI: true
            })

        }

        if (e.fieldName == 'Check2') {

            e.preventDefault();

            owner.performServerCommand({
                cmd: 'CheckListCkecked',
                submitModel: true,
                extraData: {
                    rowIdx: e.rowIdx,
                    fieldName: 'Check2',
                    value: e.newValue
                },
                blockUI: true
            })
        }
    },

    onCheckAll1: function (e) {
        var me = this,
            owner = me;

        var grid = me.getDomainProperty('dgLeasingApplicationCheckListCollection_Property');

        var cat = grid.commands;

        var aux = false;
        if (e.IconCode == 'square-o')
            aux = true;

        

        owner.performServerCommand({
            cmd: 'CheckUncheckAll',
            submitModel: true,
            extraData: {
                fieldName: 'Checked',
                value: !aux
            },
            blockUI: true
        })
    },

    onCheckAll2: function (e) {
        var me = this,
           owner = me;
        var grid = me.getDomainProperty('dgLeasingApplicationCheckListCollection_Property');

        var cat = grid.commands;

        var aux = false;
        if (e.IconCode == 'square-o')
            aux = true;

        

        owner.performServerCommand({
            cmd: 'CheckUncheckAll',
            submitModel: true,
            extraData: {
                fieldName: 'Check2',
                value: !aux
            },
            blockUI: true
        })
    }



});